import { lottiesPaths } from 'Constants/lottiesPaths';
import { stages } from 'Constants/stages';

export const afterFlowLotties = {
  [stages.PENDING_AUTOMATIC_MODIFICATIONS]: lottiesPaths.MORE_INFO,
  [stages.PENDING_MANUAL_MODIFICATIONS]: lottiesPaths.MORE_INFO,
  [stages.FILED_MANUAL]: lottiesPaths.FILED,
  [stages.FINISHED]: lottiesPaths.FILED_NOT_RETURN,
  [stages.FINISHED_NOT_SUCCESS]: lottiesPaths.DISCARDED,
};
